import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/presentation/app.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { APP_ROUTES } from '@view/routes';
import { securityInterceptRequestService } from '@infra/security/http-interceptors/interceptor-request.service';

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(APP_ROUTES),
    provideHttpClient(withInterceptors([securityInterceptRequestService])),
    provideAnimations()
  ]
}).catch((err) => console.error(err));
